/* eslint-disable */
export default {
  "sys": {
    "type": "Array"
  },
  "total": 3,
  "skip": 0,
  "limit": 10,
  "items": [
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "j8nzv6dy3jwc"
          }
        },
        "id": "5wgTBLYiwPtZvyVs84psR4",
        "type": "Entry",
        "createdAt": "2020-09-02T16:31:04.197Z",
        "updatedAt": "2020-09-02T16:36:02.961Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 2,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "article"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "date": "2020-09-04",
        "title": "Test with Image",
        "banner": [
          {
            "sys": {
              "type": "Link",
              "linkType": "Asset",
              "id": "3KKUfCB4RHekifZB9K1QEq"
            }
          }
        ],
        "body": {
          "data": {},
          "content": [
            {
              "data": {},
              "content": [
                {
                  "data": {},
                  "marks": [],
                  "value": "Test with image and link.",
                  "nodeType": "text"
                }
              ],
              "nodeType": "paragraph"
            }
          ],
          "nodeType": "document"
        },
        "link": "https://www.pagerduty.com/"
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "j8nzv6dy3jwc"
          }
        },
        "id": "20fgu5No679DIqUkw93NBM",
        "type": "Entry",
        "createdAt": "2020-09-02T15:53:25.751Z",
        "updatedAt": "2020-09-02T16:29:29.774Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 5,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "article"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "date": "2020-09-03",
        "title": "Video Test",
        "banner": [
          {
            "sys": {
              "type": "Link",
              "linkType": "Asset",
              "id": "66kd95b9hAyiA1tdyZCqiE"
            }
          }
        ],
        "body": {
          "nodeType": "document",
          "data": {},
          "content": [
            {
              "nodeType": "paragraph",
              "content": [
                {
                  "nodeType": "text",
                  "value": "Test with video and no link.",
                  "marks": [],
                  "data": {}
                }
              ],
              "data": {}
            }
          ]
        }
      }
    },
    {
      "sys": {
        "space": {
          "sys": {
            "type": "Link",
            "linkType": "Space",
            "id": "j8nzv6dy3jwc"
          }
        },
        "id": "6LQedjX8wB6Zto2XbKiVFi",
        "type": "Entry",
        "createdAt": "2020-09-01T00:11:01.926Z",
        "updatedAt": "2020-09-02T15:52:32.390Z",
        "environment": {
          "sys": {
            "id": "master",
            "type": "Link",
            "linkType": "Environment"
          }
        },
        "revision": 6,
        "contentType": {
          "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "article"
          }
        },
        "locale": "en-US"
      },
      "fields": {
        "date": "2020-08-31",
        "title": "🥳 Rich Text Test with no Image",
        "body": {
          "nodeType": "document",
          "data": {},
          "content": [
            {
              "nodeType": "unordered-list",
              "content": [
                {
                  "nodeType": "list-item",
                  "content": [
                    {
                      "nodeType": "paragraph",
                      "content": [
                        {
                          "nodeType": "text",
                          "value": "New Feature\n",
                          "marks": [
                            {
                              "type": "bold"
                            }
                          ],
                          "data": {}
                        }
                      ],
                      "data": {}
                    },
                    {
                      "nodeType": "unordered-list",
                      "content": [
                        {
                          "nodeType": "list-item",
                          "content": [
                            {
                              "nodeType": "paragraph",
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "",
                                  "marks": [],
                                  "data": {}
                                },
                                {
                                  "nodeType": "hyperlink",
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "My On-Call Shifts",
                                      "marks": [
                                        {
                                          "type": "underline"
                                        }
                                      ],
                                      "data": {}
                                    }
                                  ],
                                  "data": {
                                    "uri": "https://support.pagerduty.com/docs/my-on-call-shifts"
                                  }
                                },
                                {
                                  "nodeType": "text",
                                  "value": " ",
                                  "marks": [
                                    {
                                      "type": "underline"
                                    }
                                  ],
                                  "data": {}
                                },
                                {
                                  "nodeType": "text",
                                  "value": "allows users to view their shifts across all escalation policies and schedules in a single, easy-to-use view. This feature displays if a user is on call now, a list of their associated shifts and what their schedule is for the upcoming weeks and months. Users can now easily create override shifts across multiple schedules because all of the shifts are accessible in one place. My On-Call Shifts is also available as a widget on the right side of the Incidents page, displaying their current shift, and when they are on call next. ",
                                  "marks": [],
                                  "data": {}
                                },
                                {
                                  "nodeType": "hyperlink",
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Read More",
                                      "marks": [
                                        {
                                          "type": "underline"
                                        }
                                      ],
                                      "data": {}
                                    }
                                  ],
                                  "data": {
                                    "uri": "https://support.pagerduty.com/docs/my-on-call-shifts"
                                  }
                                },
                                {
                                  "nodeType": "text",
                                  "value": "",
                                  "marks": [],
                                  "data": {}
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "paragraph",
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "",
                                  "marks": [],
                                  "data": {}
                                }
                              ],
                              "data": {}
                            }
                          ],
                          "data": {}
                        }
                      ],
                      "data": {}
                    }
                  ],
                  "data": {}
                },
                {
                  "nodeType": "list-item",
                  "content": [
                    {
                      "nodeType": "paragraph",
                      "content": [
                        {
                          "nodeType": "text",
                          "value": "Improvements\n",
                          "marks": [
                            {
                              "type": "bold"
                            }
                          ],
                          "data": {}
                        }
                      ],
                      "data": {}
                    },
                    {
                      "nodeType": "unordered-list",
                      "content": [
                        {
                          "nodeType": "list-item",
                          "content": [
                            {
                              "nodeType": "paragraph",
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "",
                                  "marks": [],
                                  "data": {}
                                },
                                {
                                  "nodeType": "hyperlink",
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "New Visibility Console:",
                                      "marks": [
                                        {
                                          "type": "underline"
                                        }
                                      ],
                                      "data": {}
                                    }
                                  ],
                                  "data": {
                                    "uri": "https://support.pagerduty.com/docs/visibility-console"
                                  }
                                },
                                {
                                  "nodeType": "text",
                                  "value": " ",
                                  "marks": [
                                    {
                                      "type": "underline"
                                    }
                                  ],
                                  "data": {}
                                },
                                {
                                  "nodeType": "text",
                                  "value": "The newly redesigned Visibility Console provides users with the single pane-of-glass experience to effectively monitor their digital operations in real time. This feature provides Central Ops / NOC teams and technical stakeholders with context on their technical environment at a glance, allowing them to quickly understand the health of their digital operations. ",
                                  "marks": [],
                                  "data": {}
                                },
                                {
                                  "nodeType": "hyperlink",
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Read More",
                                      "marks": [
                                        {
                                          "type": "underline"
                                        }
                                      ],
                                      "data": {}
                                    }
                                  ],
                                  "data": {
                                    "uri": "https://support.pagerduty.com/docs/visibility-console"
                                  }
                                },
                                {
                                  "nodeType": "text",
                                  "value": "\n",
                                  "marks": [
                                    {
                                      "type": "underline"
                                    }
                                  ],
                                  "data": {}
                                }
                              ],
                              "data": {}
                            }
                          ],
                          "data": {}
                        },
                        {
                          "nodeType": "list-item",
                          "content": [
                            {
                              "nodeType": "paragraph",
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "",
                                  "marks": [],
                                  "data": {}
                                },
                                {
                                  "nodeType": "hyperlink",
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Dependency-Aware Related Incidents:",
                                      "marks": [
                                        {
                                          "type": "underline"
                                        }
                                      ],
                                      "data": {}
                                    }
                                  ],
                                  "data": {
                                    "uri": "https://support.pagerduty.com/docs/related-incidents#dependency-aware-related-incidents"
                                  }
                                },
                                {
                                  "nodeType": "text",
                                  "value": " To help responders gain a better understanding of the breadth and scope of incident impact, we’ve enhanced PagerDuty’s Related Incidents capability set with Dependency-Aware Related Incidents to provide real-time, contextual insights across multiple services and teams. ",
                                  "marks": [],
                                  "data": {}
                                },
                                {
                                  "nodeType": "hyperlink",
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Read More",
                                      "marks": [
                                        {
                                          "type": "underline"
                                        }
                                      ],
                                      "data": {}
                                    }
                                  ],
                                  "data": {
                                    "uri": "https://support.pagerduty.com/docs/related-incidents#dependency-aware-related-incidents"
                                  }
                                },
                                {
                                  "nodeType": "text",
                                  "value": "\n",
                                  "marks": [
                                    {
                                      "type": "underline"
                                    }
                                  ],
                                  "data": {}
                                }
                              ],
                              "data": {}
                            }
                          ],
                          "data": {}
                        },
                        {
                          "nodeType": "list-item",
                          "content": [
                            {
                              "nodeType": "paragraph",
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "",
                                  "marks": [],
                                  "data": {}
                                },
                                {
                                  "nodeType": "hyperlink",
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Delayed incident notification",
                                      "marks": [
                                        {
                                          "type": "underline"
                                        }
                                      ],
                                      "data": {}
                                    }
                                  ],
                                  "data": {
                                    "uri": "https://support.pagerduty.com/docs/rulesets#paused-incident-notifications"
                                  }
                                },
                                {
                                  "nodeType": "text",
                                  "value": ": Stop responders from having to respond to un-actionable transient problems and provide time for systems to attempt to self heal or for a problem to return to an acceptable state, without unnecessary notifications. ",
                                  "marks": [],
                                  "data": {}
                                },
                                {
                                  "nodeType": "hyperlink",
                                  "content": [
                                    {
                                      "nodeType": "text",
                                      "value": "Read More",
                                      "marks": [
                                        {
                                          "type": "underline"
                                        }
                                      ],
                                      "data": {}
                                    }
                                  ],
                                  "data": {
                                    "uri": "https://support.pagerduty.com/docs/rulesets#paused-incident-notifications"
                                  }
                                },
                                {
                                  "nodeType": "text",
                                  "value": "\n",
                                  "marks": [
                                    {
                                      "type": "underline"
                                    }
                                  ],
                                  "data": {}
                                }
                              ],
                              "data": {}
                            }
                          ],
                          "data": {}
                        },
                        {
                          "nodeType": "list-item",
                          "content": [
                            {
                              "nodeType": "paragraph",
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "Status Update notification preferences: Users can now configure notification rules for status updates, and new users will also be automatically set up with default status update notification rules. How to access: Click on “My Profile” and then go to “Notification Rules” tab to configure.",
                                  "marks": [],
                                  "data": {}
                                }
                              ],
                              "data": {}
                            },
                            {
                              "nodeType": "paragraph",
                              "content": [
                                {
                                  "nodeType": "text",
                                  "value": "",
                                  "marks": [],
                                  "data": {}
                                }
                              ],
                              "data": {}
                            }
                          ],
                          "data": {}
                        }
                      ],
                      "data": {}
                    }
                  ],
                  "data": {}
                }
              ],
              "data": {}
            },
            {
              "nodeType": "paragraph",
              "content": [
                {
                  "nodeType": "text",
                  "value": "",
                  "marks": [],
                  "data": {}
                }
              ],
              "data": {}
            }
          ]
        }
      }
    }
  ],
  "includes": {
    "Asset": [
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "j8nzv6dy3jwc"
            }
          },
          "id": "3KKUfCB4RHekifZB9K1QEq",
          "type": "Asset",
          "createdAt": "2020-09-02T16:30:59.380Z",
          "updatedAt": "2020-09-02T16:30:59.380Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "Test Image",
          "description": "Image Alt Description",
          "file": {
            "url": "//images.ctfassets.net/j8nzv6dy3jwc/3KKUfCB4RHekifZB9K1QEq/24abf52d77474b3302816c519d780107/resources-thumb-webinar-4-e1599005127301.png",
            "details": {
              "size": 35802,
              "image": {
                "width": 300,
                "height": 300
              }
            },
            "fileName": "resources-thumb-webinar-4-e1599005127301.png",
            "contentType": "image/png"
          }
        }
      },
      {
        "sys": {
          "space": {
            "sys": {
              "type": "Link",
              "linkType": "Space",
              "id": "j8nzv6dy3jwc"
            }
          },
          "id": "66kd95b9hAyiA1tdyZCqiE",
          "type": "Asset",
          "createdAt": "2020-09-02T16:07:47.911Z",
          "updatedAt": "2020-09-02T16:07:47.911Z",
          "environment": {
            "sys": {
              "id": "master",
              "type": "Link",
              "linkType": "Environment"
            }
          },
          "revision": 1,
          "locale": "en-US"
        },
        "fields": {
          "title": "Test Video",
          "file": {
            "url": "//videos.ctfassets.net/j8nzv6dy3jwc/66kd95b9hAyiA1tdyZCqiE/dbd1ec2c6ac4db5c4879abaca53d534b/videoplayback.mp4",
            "details": {
              "size": 3917385
            },
            "fileName": "videoplayback.mp4",
            "contentType": "video/mp4"
          }
        }
      }
    ]
  }
};
